"use client";
import { LoaderComponent, SnackbarComponent } from "@/components";
import ApplicationConfig from "@/components/Wrappers/ApplicationConfig";
import { useRouter } from "@/i18n/routing";
import {
  errorValidator,
  GET_PRODUCT_APPLICATION,
  PRODUCTS,
} from "@/lib/constants";
import useStageErrorHandler from "@/lib/hooks/stageErrorHandler";
import {
  useGetApplicationConfigQuery,
  useGetLoanStatusQuery,
  useGetMyLoansQuery,
} from "@/lib/redux";
import { Stack } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import ActiveLoanCardList from "./active-loans";
import ImageCarousel from "./carousel";
import ProductsList from "./explore-products";
import LoanStatusList from "./loan-status";
import DashboardNav from "./navbar";

const DashboardScreen = () => {
  const router = useRouter();
  /*************************************STATE*****************************/
  const [tokenExist, setTokenExist] = useState(false);
  const [maintenanceModalVisible, setMaintenanceModalVisible] = useState(false);
  /*************************************RTK QUERY*****************************/
  const {
    data: loanStatusData,
    error: errorLoanStatus,
    refetch: refetchLoanStatusData,
    isUninitialized: isUninitializedLoanStatus,
    isLoading: isLoadingLoanStatus,
  } = useGetLoanStatusQuery(null, {
    skip: !tokenExist,
  });

  // const {
  //   data: activeLoansData,
  //   error: errorMyLoans,
  //   refetch: refetchMyLoansData,
  //   isUninitialized: isUninitializedMyLoans,
  //   isLoading: isLoadingActiveLoans,
  // } = useGetMyLoansQuery(null, {
  //   skip: !tokenExist,
  // });

  const {
    data: applicationConfigData,
    isFetching,
    refetch: refetchApplicationConfigData,
  } = useGetApplicationConfigQuery();
  const serverConfig = applicationConfigData?.data?.serverconfig;
  const isLoading = isLoadingLoanStatus;
  const isError = errorLoanStatus;
  /*************************************EFFECT*****************************/
  //dispaly errors
  useEffect(() => {
    if (isError) {
      if (isError?.status === 401) {
        SnackbarComponent({
          error: isError,
          errorMessage: "Your session has expired. Please login again",
        });
        sessionStorage.clear();
        router.refresh();
      } else {
        if (isError) {
          SnackbarComponent({
            error: isError,
            errorMessage: errorValidator(isError),
          });
          return;
        }
        SnackbarComponent({
          error: isError,
          errorMessage: "Something Went wrong. Please try again",
        });
      }
    }
  }, [isError]);

  const refetchLoanStatus = useCallback(() => {
    if (!isUninitializedLoanStatus) {
      refetchLoanStatusData();
    }
  }, [isUninitializedLoanStatus, refetchLoanStatusData]);

  // const refetchMyLoans = useCallback(() => {
  //   if (!isUninitializedMyLoans) {
  //     refetchMyLoansData();
  //   }
  // }, [isUninitializedMyLoans, refetchMyLoansData]);

  useEffect(() => {
    const fetchToken = async () => {
      const token = await sessionStorage.getItem("token");
      if (token) {
        setTokenExist(true);
        refetchLoanStatus();
        // refetchMyLoans();
        router.refresh();
      }
    };
    fetchToken();
  }, []);

  useEffect(() => {
    if (serverConfig) setMaintenanceModalVisible(serverConfig?.isServerDown);
  }, [serverConfig?.isServerDown]);

  /*************************************ACTION*****************************/

  const handleRouting = (dateStatus) => {
    if (!dateStatus) {
      refetchApplicationConfigData();
    }
  };

  // useStageErrorHandler({
  //   stage: productApplication?.stage,
  //   prevStage: productApplication?.previousStage,
  //   message: productApplication?.loanReapplyMessage,
  // });

  /*************************************RENDER*****************************/

  return (
    <>
      <LoaderComponent open={isLoading} />
      <DashboardNav tokenExist={tokenExist} setTokenExist={setTokenExist} />
      <ImageCarousel />
      <Stack px={{ md: 3, xs: 1 }} py={2} rowGap={4}>
        <LoanStatusList loanStatusData={loanStatusData} isLoading={isLoading} />
        {/* <ActiveLoanCardList
          activeLoansData={activeLoansData}
          isLoading={isLoading}
        /> */}
        <ProductsList tokenExist={tokenExist} />
        <ApplicationConfig
          open={maintenanceModalVisible}
          route={handleRouting}
          serverConfig={serverConfig}
        />
      </Stack>
    </>
  );
};

export default DashboardScreen;
